var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"main-panel"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }